import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useAdHocSubmitMutation = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending, isError } = useMutationState({
        mutationFn: (param)=>{
            let { relationshipId, data } = param;
            return api.billing.submitCharges(relationshipId, data);
        }
    });
    return {
        submitAdHoc: mutateAsync,
        isLoading: isPending,
        isError
    };
};
